import { FoodsTags, WhiteBox } from "@foodpilot/foods";
import { useTheme, Box, Stack, Typography } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { DiagnosticProps } from "../diagnostic.types";
import { ScoreService } from "src/services/ScoreService";
import { RegulatoryScoreMapping } from "src/api/client-api/company/overview/useOrganizationOverviewOneSsq.tsx";
import { useTranslation } from "react-i18next";
import { DiagnosticActions } from "./DiagnosticActions";
import { OlapScoresService } from "src/context/OlapScores/OlapScoresService";

export const RegulationDiagnostic = (props: DiagnosticProps) => {
    const { diagnostic } = props;

    const ssqId = diagnostic?.id ?? -99;
    const completion = props.diagnostic?.post?.completion ?? 0;
    const isLocked = props.diagnostic?.post?.isLocked;
    const isLockedOrCompleted = isLocked || completion === 100;

    // TODO: Get the number of validated regulation scores from the post scores
    const regulationScore = OlapScoresService.normalizeJsonScore(diagnostic?.post?.scores?.score.value);

    return (
        <Fragment>
            <DiagnosticActions ssqId={ssqId} scoreId={props.scoreId} isComplete={isLockedOrCompleted} />
            {ScoreService.isScoreRegulatory(regulationScore, props.score.displayMode) && (
                <RegulationList score={regulationScore} />
            )}
        </Fragment>
    );
};

type RegulationListProps = {
    score: RegulatoryScoreMapping;
};
const RegulationList = (props: RegulationListProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const { score } = props;
    const items = Object.values(score).flatMap((i) => {
        if (i.required === false) return [];

        const tags = i.tags;
        const selectedTag = tags.length > 0 ? tags[0] : "unknown";
        return [
            {
                title: i.title,
                groupKey: selectedTag,
            },
        ];
    });
    const groupedItems = Object.groupBy(items, (i) => i.groupKey);

    return (
        <WhiteBox>
            <Stack padding={theme.spacing(4)} gap={theme.spacing(4)}>
                <Typography variant="h3">
                    {t(
                        "company.dashboard.regulatory.introduction",
                        "{{nbActions}} lawful requirements for your company:",
                        { nbActions: items.length },
                    )}
                </Typography>
                {Object.entries(groupedItems).map(([k, v]) => {
                    return (
                        <Stack key={k} gap={theme.spacing(1)}>
                            <Box>
                                <FoodsTags label={k} variant="tags-grey" />
                            </Box>
                            {v?.map((i, index) => {
                                return (
                                    <Typography key={`${i.title}-${index}`} variant="body-medium">
                                        {i.title}
                                    </Typography>
                                );
                            })}
                        </Stack>
                    );
                })}
            </Stack>
        </WhiteBox>
    );
};
